import React, {useMemo, useState} from "react";
import FileSaver from "file-saver";
import {Button} from "antd";
import {MARGIN_SM} from "../../../../../../styles/constants";

export const DEFAULT_SHOWN_VALIDATION_DATA = 100;

const parseValidationObject = data => [`${Object.keys(data).join(",")}\n${Object.values(data).map(item => `"${Array.isArray(item) ? item.join(",") : item}"`).join(",")}`];

const parseValidationArray = (data, field) => [`${field}\n${(data || []).map(item => `"${item}"`).join("\n")}`];

const parseValidationTextFormatErrors = data => [`${(data || []).map(item => item.componentId).join(",")}\n${(data || []).map(item => item.valuesErrors.map(err => `${err.value}: "${err.errors}"`)).join(",")}`];

export const onDownloadErrors = (data, selectedMappingSet) => {
    const headers = Object.keys(data || {}).filter(field => field.trim().toLowerCase() !== 'status' && field.trim().toLowerCase() !== 'errormessage');
    for (const field of headers) {
        let file;
        if ((typeof data[field] === 'object' && Object.keys(data[field]).length === 0) || (Array.isArray(data[field]) && data[field].length === 0)) continue;

        if (Array.isArray(data[field])) {
            file = new File(
                parseValidationArray(data[field], field),
                `data_validation_${field}_${selectedMappingSet ? selectedMappingSet.name : ""}_${new Date().toISOString()}.csv`,
                {type: "text/csv;charset=utf-8"}
            );
        } else if (field === "TextFormatErrors") {
            file = new File(
                parseValidationTextFormatErrors(data[field]),
                `data_validation_${field}_${selectedMappingSet ? selectedMappingSet.name : ""}_${new Date().toISOString()}.csv`,
                {type: "text/csv;charset=utf-8"}
            );
        } else {
            file = new File(
                parseValidationObject(data[field]),
                `data_validation_${field}_${selectedMappingSet ? selectedMappingSet.name : ""}_${new Date().toISOString()}.csv`,
                {type: "text/csv;charset=utf-8"}
            );
        }

        if (!file) continue;

        FileSaver.saveAs(file, `data_validation_${field}_${new Date().toISOString()}.csv`);
    }
}

export const BatchedArrayData = ({data, renderData, t, maxRowsErrorMappingValidation}) => {
    const [shownDataLength, setShownDataLength] = useState(maxRowsErrorMappingValidation || DEFAULT_SHOWN_VALIDATION_DATA);
    const shownData = useMemo(() => data.slice(0, shownDataLength), [data, shownDataLength])
    return (
        <div style={{overflowY: "auto", maxHeight: "40vh"}}>
            <div>
                {shownData.map((item, idx) => renderData(item, idx))}
            </div>
            {shownData.length < data.length ? (
                <div style={{marginTop: MARGIN_SM}}>
                    <Button
                        onClick={() => setShownDataLength(prevState => prevState + (maxRowsErrorMappingValidation || DEFAULT_SHOWN_VALIDATION_DATA))}>{t("scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.loadMoreDataButton")}&nbsp;({shownData.length}/{data.length})</Button>
                </div>
            ) : null}
        </div>
    )
}
